import { Modal, Button } from "react-bootstrap";
import { useState } from "react";
import { OrderItemSummary } from "../../../../types/Order/orderItemSummary";
import { OrderLineItem } from "../../../../types/Order/OrderLineItem";
import { StyledModalTitle } from "../../../../@ui/StyledModalTitle";
import ThemedModal from "../../../../@ui/Modal/ThemedModal";
import RenewalEmailTable from "./RenewalEmailTable";
import { DateTime } from "luxon";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { useOrderService } from "../../../../hooks";

interface ManageRenewalModalProps {
  orderItem: OrderItemSummary;
  lineItem: OrderLineItem;
  onClose: () => void;
}

const ManageRenewalModal = ({
  orderItem,
  lineItem,
  onClose,
}: ManageRenewalModalProps) => {
  const orderService = useOrderService();
  const [deleted, setDeleted] = useState(!!lineItem.dataDeleted);
  const [deleting, setDeleting] = useState(false);

  const markDataDeleted = () => {
    setDeleting(true);
    orderService
      .SetOrderItemDataDeleted(orderItem.orderItemId)
      .then(() => setDeleted(true))
      .catch(() => {})
      .finally(() => setDeleting(false));
  };

  return (
    <ThemedModal show={true} centered onHide={onClose} size="lg">
      <Modal.Header className="bg-secondary text-white" closeButton>
        <StyledModalTitle>Manage Renewal</StyledModalTitle>
      </Modal.Header>
      <Modal.Body>
        <p>
          <strong>Product:</strong> {orderItem.product}
        </p>
        <p>
          <strong>
            {orderItem.dataExpiry && orderItem.dataExpiry > DateTime.now() ?
              "Expires:"
            : "Expired:"}
          </strong>{" "}
          {orderItem.dataExpiry?.toFormat("dd/MM/yyyy")}
        </p>
        {lineItem.renewalEmails && lineItem.renewalEmails.length > 0 && (
          <div className="d-flex justify-content-between align-items-center">
            <p className="mb-0">
              <strong>Email:</strong> {lineItem.renewalEmails[0].email}
            </p>
            <Button
              variant={deleted ? "secondary" : "danger"}
              size="sm"
              disabled={deleted || deleting}
              onClick={markDataDeleted}
            >
              {deleted ? (
                <>
                  <FontAwesomeIcon icon={faCheck} className="me-1" />
                  Data Deleted
                </>
              ) : (
                "Mark Data as Deleted"
              )}
            </Button>
          </div>
        )}
        <RenewalEmailTable emails={lineItem.renewalEmails ?? []} />
      </Modal.Body>
    </ThemedModal>
  );
};

export default ManageRenewalModal;
